
export const USD = (val)=> {
  if (!val) {
    return '$0';
  }
  return parseFloat(val).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};



// WEBPACK FOOTER //
// ./src/app/libs/formatter.js